import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisconnectedSaleHeaderComponent } from './disconnected-sale-header.component';



@NgModule({
  declarations: [
    DisconnectedSaleHeaderComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DisconnectedSaleHeaderComponent
  ],
})
export class DisconnectedSaleHeaderModule { }
